module.exports = __webpack_public_path__ + "static/media/icon-danse.aeb81359.svg";